
import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, unit, change, changeType, icon, color = 'blue' }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-green-600';
    if (changeType === 'negative') return 'text-red-600';
    return 'text-gray-500';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const colorMap = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    purple: 'bg-purple-50 text-purple-600',
    orange: 'bg-orange-50 text-orange-600'
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-xs hover:shadow-sm transition-shadow duration-200">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorMap[color] || colorMap.blue}`}>
          <Icon name={icon} size={20} />
        </div>
        <div className={`flex items-center space-x-1 text-xs ${getChangeColor()}`}>
          <Icon name={getChangeIcon()} size={14} />
          <span className="font-medium">{change}</span>
        </div>
      </div>
      
      <div>
        <h3 className="text-xs font-medium text-gray-600 uppercase tracking-wide mb-1">{title}</h3>
        <div className="flex items-baseline space-x-1">
          <span className="text-xl font-bold text-gray-900">{value}</span>
          {unit && <span className="text-sm text-gray-500">{unit}</span>}
        </div>
      </div>
    </div>
  );
};

export default KPICard;